<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-mafiaways">
      <div class="px-3 col-3 p-0">
        <div class="heading-mafiaways">{{ $t("result.round") }}</div>
        <div class="text-subhead-mafiaways">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-mafiaways">
          Exchange Coin
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-mafiaways">
          {{ $t("result.balance") + `${currency}` }}
        </div>
        <div class="text-subhead-mafiaways">
          {{ (data.balance ) | currencyFormatter }}
        </div>
      </div>
    </div>
    <div class="content-result-mafiaways pt-3">
      <div class="text-games-mafiaways">{{ data.game.prefix.toUpperCase() }}</div>
      <div class="text-date mb-1">{{ data.timestamp  }}</div>
      <div class="image-container">
        <div>
          <img class="image-coin" :src="require(`../../assets/resultCoin/amscoin.png`) " alt="" />
          <div class="text-price">{{ data.bet| currencyFormatter }}</div>
        </div>
        <div>
          <img class="image-arrow-big" :src="require(`../../assets/resultPoint/arrow.png`) " alt="" />
          <div class="text-arrow">EXCHANGE</div>
        </div>
        <div>
          <img class="image-coin" :src="require(`../../assets/resultCoin/bag.png`) " alt="" />
          <div class="text-price">{{ data.winlose | currencyFormatter}}</div>
        </div>
      </div>
      <div class="line"></div>
      <div class="image-container-below">
        <div>
          <div class="text-price">Before Balance</div>
          <div class="text-price m-0">{{ data.balanceBefore | currencyFormatter }}</div>
        </div>
        <div>
          <img class="image-arrow" :src="require(`../../assets/resultPoint/arrow.png`) " alt="" />
        </div>
        <div>
          <div class="text-price">After Balance</div>
          <div class="text-price m-0">{{ data.balance | currencyFormatter }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-coin",
  props: {
    data: Object,
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t)
      ,
      date: "",
      time: "",
      currency: this.data.currency ? this.data.currency : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      state: "SPIN",
      multiplier: 0,
      reels: [],
    };
  },
  async created() {
    if (!this.currency.includes("(")) {
      this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
    }
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName(
        "header-mafiaways"
      )[0].offsetHeight;
    },
  },
};
</script>
<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933;
  margin: 0;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.image-container-below {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 20px;
}

.image-container-below img {
  margin: 0 80px;
  margin-top: 20px;
}

.image-container img {
  margin: 0 60px;
  margin-top: 80px;
}

.line {
  width: 50px; /* Adjust the width of the line */
  border-bottom: 1px solid black; /* Adjust color and style as needed */
  margin: 0 10px;
  margin-top: 10px;
}

.text-price {
  margin-top: 20px;
  color: #fff;
  text-align: center;
  font-size: 20px;
}

.text-arrow {
  margin-top: 45px;
  color: #24e676;
  text-align: center;
  font-size: 30px;
}

.image-arrow {
  width: 45px;
  height: 45px;
}

.image-arrow-big {
  width: 45px;
  height: 45px;
}

.image-diamond {
  width: 172px;
  height: 91px;
}

.arrow-position {
  transform: translate(0px, 86px);
}

.win-container {
  height: fit-content;
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.text-win {
  height:x;
}

.fg-image {
  width: 570px;
}

.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-mafiaways {
  width: 140px;
  height: 144px;
  padding: 4px;
}

.icon-bonus-mafiaways {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-mafiaways {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}
.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-mafiaways {
  /* background: #0c161f; */
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  /* overflow-y: scroll; */
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.multiplier-box-mafiaways {
  /* background: #0c161f; */
  border-radius: 10px;
  min-height: 50px;
  max-height: 100px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.bonus-box-mafiaways {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-mafiaways .item {
  color: #fff;
  /* background: #06112d; */
  line-height: 1;
  border-radius: 10px;
  /* border: 1.5px solid #cac095; */
}

.bet-box-mafiaways .bet-wrapper-mafiaways:not(:first-child) .item {
  margin-top: 10px;
  /* width: 800px; */
}

.bet-wrapper-mafiaways,
.result-wrapper {
  font-size: 35px;
  /* width: 800px; */
}

.header-mafiaways {
  background: #6DD38A;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-mafiaways > div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-mafiaways {
  color: #fff;
  text-align: center;
}

.content-result-mafiaways {
  background: #2E3B3E;
  height: 250vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title > .heading-mafiaways {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title > .sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-mafiaways {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-mafiaways {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-subgame-mafiaways {
  font-size: 20px;
  color: #ffd500;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #fff;
  text-align: center;
}

@media screen and (max-width: 1030px) {
  .table-mafiaways {
    background-size: 649px 600px;
    width: 649px;
    height: 600px;
    transform: translate(0px, -114px);
  }
}

@media screen and (min-width: 1060px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }
}

.line {
  background-color: #000000;
  height: 2px;
  width: 100%;
}

@media screen and (max-width: 770px) {
  .heading-mafiaways {
    font-size: 18px;
  }
}

@media screen and (max-width: 800px) {
  .table-mafiaways {
    background-size: 664px 600px;
    width: 664px;
    height: 600px;
    transform: translate(0px, -108px);
  }
}

@media screen and (max-width: 780px) {
  .top-reel {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 67%;
    transform: translate(105px, 0px);
  }
}

@media screen and (max-width: 600px) {
  .table-mafiaways {
    background-size: 498px 460px;
    width: 498px;
    height: 460px;
    transform: translate(0px, -93px);
  }

  .image-container-below img {
    margin: 0 60px;
    margin-top: 20px;
  }

  .image-container img {
    margin: 0 40px;
    margin-top: 80px;
  }

  .text-price {
    font-size: 16px;
  }

  .text-arrow {
    font-size: 20px;
  }

  .image-arrow {
    width: 35px;
    height: 35px;
  }
}

@media screen and (max-width: 550px) {
  .fg-image {
    width: 390px;
  }

  .image-container-below img {
    margin: 0 40px;
    margin-top: 20px;
  }

  .image-container img {
    margin: 0 20px;
    margin-top: 80px;
  }

  .text-arrow {
    font-size: 10px;
  }

  .image-arrow-big {
    width: 30px;
    height: 30px;
  }

  .image-coin {
    width: 120px;
  }

  .image-diamond {
    width: 120px;
    height: 62px;
  }

}

@media screen and (max-width: 400px) {
  .image-container-below img {
    margin: 0 40px;
    margin-top: 20px;
  }

  .image-container img {
    margin: 0 20px;
    margin-top: 80px;
  }

  .text-price {
    font-size: 10px;
  }

  .text-arrow {
    font-size: 10px;
  }

  .image-arrow {
    width: 15px;
    height: 15px;
  }
  
  .image-arrow-big {
    width: 20px;
    height: 20px;
  }

  .image-coin {
    width: 100px;
  }

  .image-diamond {
    width: 100px;
    height: 52px;
  }
}
</style>
